import { create } from '../deferred';

// 从 account.ts 重新导出已有的 deferred
export { accountDeferred, prepareTokenDeferred } from '../account';

// defer.ts 中只定义 productShellDeferred
export const productShellDeferred = create<() => void>();
